// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Crew Training Configuration
 * 
 * Defines training programs for crew skill development
 */

export const TRAINING_PROGRAMS = {
  COMBAT: {
    id: 'combat',
    name: 'Combat Training',
    description: 'Weapons handling and tactical combat skills',
    icon: '⚔️',
    duration: 7, // days
    cost: 500,
    requirements: {
      minExperience: 'ROOKIE',
      roles: ['gunner', 'pilot', 'generic']
    },
    rewards: {
      xp: 75,
      skillBonuses: {
        weaponAccuracy: 0.1,
        combatReflexes: 0.15
      }
    }
  },
  
  TECHNICAL: {
    id: 'technical',
    name: 'Technical Training',
    description: 'Engineering and systems maintenance',
    icon: '🔧',
    duration: 10, // days
    cost: 750,
    requirements: {
      minExperience: 'ROOKIE',
      roles: ['engineer', 'scientist', 'generic']
    },
    rewards: {
      xp: 100,
      skillBonuses: {
        repairEfficiency: 0.2,
        systemDiagnostics: 0.15
      }
    }
  },
  
  LEADERSHIP: {
    id: 'leadership',
    name: 'Leadership Training',
    description: 'Command skills and crew management',
    icon: '👑',
    duration: 14, // days
    cost: 1000,
    requirements: {
      minExperience: 'EXPERIENCED',
      roles: ['pilot', 'medic', 'scientist']
    },
    rewards: {
      xp: 125,
      skillBonuses: {
        moraleBoost: 0.1,
        teamEfficiency: 0.15
      }
    }
  },
  
  MEDICAL: {
    id: 'medical',
    name: 'Medical Training',
    description: 'Advanced medical procedures and emergency care',
    icon: '🏥',
    duration: 12, // days
    cost: 800,
    requirements: {
      minExperience: 'TRAINED',
      roles: ['medic', 'scientist', 'generic']
    },
    rewards: {
      xp: 90,
      skillBonuses: {
        healingSpeed: 0.25,
        injuryPrevention: 0.2
      }
    }
  }
};

export const TRAINING_STATUS = {
  AVAILABLE: 'available',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  LOCKED: 'locked'
};